import React, { Suspense, useEffect } from 'react'
import PageLoader from '../../../../components/ui/pageLoader/PageLoader'
import { UpdateOtherRepresentativeData } from './Data/ResetPasswordForm.Data';
import FormCreator from '../../../../components/Forms/FormCreator';
import Buttons from '../../../../components/ui/button/Buttons';
import CenterModel from '../../../../components/ui/centerModel/CenterModel';
import { useUpdateRepresentativeDetailsMutation } from '../../../../app/services/GMPCourseProvider/GMPCoursePoviderApi';
import SwalAlert from '../../../../services/swalService/SwalService';

const UpdateOtherRepresentative = (props) => {
    const updateFormRef = React.useRef();
    const [formData, setFormData] = React.useState(UpdateOtherRepresentativeData);
    const { success, error } = SwalAlert();
    const [updateRepresentative, { isLoading: isLoading, isSuccess: isSuccess, data: updateRepresentativeRes}] = useUpdateRepresentativeDetailsMutation();

    useEffect(()=>{
        console.log(isLoading , isSuccess , updateRepresentativeRes);
        
        if (!isLoading && isSuccess && updateRepresentativeRes) {        
            props.handleClose();
            props.getRepresentativeList();
            success("Representative details has been successfully Updated");
        }
    },[isLoading,isSuccess,updateRepresentativeRes])

    useEffect(() => {
        if (props.selectedRepresentative) {
            setFormData({
                ...UpdateOtherRepresentativeData,
                initialState: {
                    ...UpdateOtherRepresentativeData.initialState,
                    nameofRepresentative: props.selectedRepresentative.nameOfMainRepresentative,
                    emailAddress: props.selectedRepresentative.email,
                    contactNumber: props.selectedRepresentative.contactNumber
                }
            });
        }
    }, [props.selectedRepresentative]);

     const handleUpdateRepresentative = () => {
        const formData = updateFormRef.current?.getFormData();
        if (!formData) return;
            const request = {
               RepresentativeId: props.selectedRepresentative?.representativeId || null,
               RepresentativeName: formData.nameofRepresentative || props.selectedRepresentative?.nameOfMainRepresentative,
               RepresentativeEmail: formData.emailAddress || props.selectedRepresentative?.email,
               RepresentativeContactNumber: formData.contactNumber || props.selectedRepresentative?.contactNumber,
            };            
            updateRepresentative(request);        
    }

    return (
       <div className="col-12 d-flex justify-content-end mt-4">
            <div clasName="reset-password-button">
                <CenterModel
                    modelTitle={"Update Representative"}
                    show={props.show}
                    handleClose={props.handleClose}
                    onUpload={props.handleClose}
                >
                    <div className='container resetPasswordForm'>
                        <div className='row d-flex justify-content-center'>
                            <div className='resetPasswordCard'>
                                <div className='p-2'>
                                    <Suspense fallback={<PageLoader />}>
                                        <div className='row'>
                                        <FormCreator
                                            ref={updateFormRef}
                                            {...formData}
                                        />
                                        <div className='col-lg-12 mt-3'>
                                            <Buttons
                                                buttonTypeClassName="btn success-btn"
                                                buttonText="Update Representative"
                                                onClick={handleUpdateRepresentative}
                                                isLoading={isLoading}
                                            />
                                        </div>
                                        </div>  
                                    </Suspense>
                                </div>
                            </div>
                        </div>
                    </div>
                </CenterModel>
            </div>
        </div>
    )
}

export default UpdateOtherRepresentative
